import * as React from "react";

function SvgCalendar({ size = "1em", ...props }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M15.75 3h-1.5V1.5h-1.5V3h-7.5V1.5h-1.5V3h-1.5c-.45 0-.75.3-.75.75v12c0 .45.3.75.75.75h13.5c.45 0 .75-.3.75-.75v-12c0-.45-.3-.75-.75-.75zM15 15H3V6h12v9z"
        fill="currentColor"
      />
      <path
        d="M5.25 11.25h1.5v1.5h-1.5v-1.5zM8.25 11.25h1.5v1.5h-1.5v-1.5zM11.25 11.25h1.5v1.5h-1.5v-1.5zM5.25 8.25h1.5v1.5h-1.5v-1.5zM8.25 8.25h1.5v1.5h-1.5v-1.5zM11.25 8.25h1.5v1.5h-1.5v-1.5z"
        fill="currentColor"
      />
    </svg>
  );
}

export default SvgCalendar;
